import React from 'react'
import { Route, Routes } from 'react-router-dom'

const Asset_ReportPage = React.lazy(
  () => import('@/features/patrimonios/pages/asset-report'),
)
const VisualizarPatrimonio = React.lazy(
  () => import('@/features/patrimonios/pages/visualizar-patrimonio'),
)
const Asset_HeaderOutlet = React.lazy(
  () => import('@/features/patrimonios/layouts/asset-header-outlet'),
)
const ListarPatrimonios = React.lazy(
  () => import('@/features/patrimonios/pages/listar-patrimonios'),
)

export default function Component() {
  return (
    <Routes>
      <Route index element={<ListarPatrimonios />} />
      <Route path=":assetId" element={<Asset_HeaderOutlet />}>
        <Route path="detalhes" element={<VisualizarPatrimonio />} />
        <Route path="relatorios" element={<Asset_ReportPage />} />
      </Route>
    </Routes>
  )
}
